input{padding:0 11px;border:1px solid #d9d9d9;height:32px}.glasgow-submitted .glasgow.ng-invalid,.reactions-submitted .reaction.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=glasgow-add-edit.component-4XA3DQRT.css.map */
